import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconOldPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M5.5 1V3H20V17.25C20 19.8734 17.8734 22 15.25 22H8.75C6.12665 22 4 19.8734 4 17.25V1H5.5ZM8 7H16V14H8V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldPhone;
